export const OVERUSED_NAMES: ReadonlySet<string> = new Set([
  'akira',
  'aldric',
  'alistair',
  'amara',
  'aria',
  'aurelia',
  'aurora',
  'cassian',
  'caspian',
  'celeste',
  'damien',
  'dorian',
  'elara',
  'elena',
  'elias',
  'elowen',
  'elysia',
  'ember',
  'evelyn',
  'finn',
  'hikari',
  'isabella',
  'isolde',
  'jax',
  'kael',
  'kaelan',
  'kaelen',
  'kai',
  'kaito',
  'kestrel',
  'lily',
  'lirael',
  'lucian',
  'lucien',
  'luna',
  'lyra',
  'marcus',
  'maya',
  'mira',
  'nyx',
  'orion',
  'raven',
  'rowan',
  'sable',
  'sage',
  'sakura',
  'sarah',
  'sebastian',
  'seraphina',
  'seraphine',
  'silas',
  'theron',
  'vaelithra',
  'vespara',
  'willow',
  'wren',
  'yuki',
  'zephyr',
  'ashford',
  'blackthorne',
  'blackwood',
  'chen',
  'frost',
  'hawthorne',
  'holloway',
  'mercer',
  'moon',
  'nightshade',
  'okafor',
  'ravenwood',
  'reyes',
  'shadow',
  'silver',
  'sinclair',
  'sterling',
  'storm',
  'thorne',
  'vance',
  'voss',
  'whitmore',
]);
